import React from 'react';
import { getApiBaseUrl } from './env';

const _apiBase = getApiBaseUrl().replace(/\/api$/, '');

const IMG_RE = /!\[(.*?)\]\(([^)]+)\)/g;

/**
 * Resolve asset URLs so they point at the correct backend host.
 * Handles the case where the LLM rewrites "/api/assets/..." as
 * "https://api/assets/...".
 */
export function fixAssetUrl(url) {
  if (!url) return url;
  let fixed = url.replace(/^https?:\/\/api\//, '/api/');
  if (!fixed.startsWith('/') && fixed.startsWith('api/'))
    fixed = '/' + fixed;
  fixed = fixed.replace(/^\/\/+/, '/');
  if (fixed.startsWith('/api/'))
    return `${_apiBase}${fixed}`;
  return url;
}

/**
 * Parse text for ![alt](url) image markdown and return an array of
 * React nodes (strings + <img> elements).
 *
 * @param {string} text       Raw text that may contain image markdown.
 * @param {number} keyOffset  Offset added to React keys to avoid collisions
 *                             when multiple segments share a parent.
 * @returns {React.ReactNode[]}
 */
export function renderTextWithImages(text, keyOffset = 0) {
  if (!text) return [text];

  const parts = [];
  let last = 0;
  let match;
  let key = 0;
  IMG_RE.lastIndex = 0;

  while ((match = IMG_RE.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(text.slice(last, match.index));
    }
    const alt = match[1];
    const src = fixAssetUrl(match[2]);
    parts.push(
      <img
        key={`img-${keyOffset}-${key++}`}
        src={src}
        alt={alt}
        loading="lazy"
        className="twt-inline-image"
      />
    );
    last = IMG_RE.lastIndex;
  }

  if (last < text.length) {
    parts.push(text.slice(last));
  }

  return parts.length > 0 ? parts : [text];
}
